module.exports = __webpack_public_path__ + "static/img/20221222094904738.73ffb4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/20221222094904738.jpg
// module id = okN/
// module chunks = 30